import React from 'react';
import ApproveFeeWaiver from './ApproveFeeWaiver';
import '../../../CommonCSS/SocietyCSS.css'

const ApprFeeWaiverApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Approve / Reject Allocated Fees Waiver</h5>
          </div>  
        </div>
        <ApproveFeeWaiver/>
      </div>
    </div >
  );
};

export default ApprFeeWaiverApp;
